'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const CrossIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="CrossIcon">
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_69_593)">
          <path
            d="M0.333313 8.49992C0.333313 9.50672 0.531617 10.5037 0.916903 11.4338C1.30219 12.364 1.86691 13.2092 2.57883 13.9211C3.29074 14.633 4.13591 15.1977 5.06607 15.583C5.99624 15.9683 6.99318 16.1666 7.99998 16.1666C9.00678 16.1666 10.0037 15.9683 10.9339 15.583C11.864 15.1977 12.7092 14.633 13.4211 13.9211C14.133 13.2092 14.6978 12.364 15.0831 11.4338C15.4683 10.5037 15.6666 9.50672 15.6666 8.49992C15.6666 7.49312 15.4683 6.49618 15.0831 5.56601C14.6978 4.63585 14.133 3.79068 13.4211 3.07877C12.7092 2.36685 11.864 1.80213 10.9339 1.41684C10.0037 1.03156 9.00678 0.833252 7.99998 0.833252C6.99318 0.833252 5.99624 1.03156 5.06607 1.41684C4.13591 1.80213 3.29074 2.36685 2.57883 3.07877C1.86691 3.79068 1.30219 4.63585 0.916903 5.56601C0.531617 6.49618 0.333313 7.49312 0.333313 8.49992Z"
            stroke={sx?.color || '#C33241'}
            strokeWidth="0.666667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.66669 5.16675L11.3334 11.8334"
            stroke={sx?.color || '#C33241'}
            strokeWidth="0.666667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.3334 5.16675L4.66669 11.8334"
            stroke={sx?.color || '#C33241'}
            strokeWidth="0.666667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

CrossIcon.propTypes = {
  sx: PropTypes.object
}
